import { render } from "./AnnotationInput.vue?vue&type=template&id=3ce9093a&scoped=true"
import script from "./AnnotationInput.vue?vue&type=script&lang=js"
export * from "./AnnotationInput.vue?vue&type=script&lang=js"

import "./AnnotationInput.vue?vue&type=style&index=0&id=3ce9093a&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce9093a"]])

export default __exports__